export interface IProgressEvent {
  loaded: number;
  total: number;
}

export const computeProgressEvent = (progressEvent: IProgressEvent) => {
  return (progressEvent.loaded / progressEvent.total) * 100;
};
